var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{attrs:{"center":{lat:-33, lng:-71},"zoom":5,"options":{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
    }}},[_c('GmapInfoWindow',{attrs:{"position":_vm.infoWindow.position,"opened":_vm.infoWindow.open,"options":_vm.infoWindow.template,"content":null},on:{"closeclick":function($event){_vm.infoWindow.open=false}}}),_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"icon":{url: require('@/assets/icons/pin.svg')},"position":{lat:m.latitude, lng: m.longitude},"clickable":true,"label":{'text':' '}},on:{"click":function($event){return _vm.openInfoWindowTemplate(m)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }